import { React, serviceClient, cache, dtos, observer, shared, observable, ui, _, Link, moment, makeObservable } from "../../common";
import AccountHeader from "../../account-header";
import { KeyboardEvent } from "react";
import PageTitle from "../../page-title";
import AutoFocus from "../../autofocus";

@observer
export default class AISessionIndex extends React.Component {
    @observable sessions: Array<dtos.AISessionInfo> = [];
    @observable pagination: any = { position: "both" };
    @observable filter: any = {};
    @observable sort: any = {};
    @observable loading = true;
    @observable pageSize = 20;
    @observable showNewSession = false;
    @observable selectedSessionIds: Array<string> = [];
    @observable newFlowPurpose = "";

    constructor(props) {
        super(props);
        makeObservable(this);
        this.pageSize = parseInt(localStorage.getItem("AISessionIndex.pagination.pageSize") || "20");
    }

    async componentDidMount() {
        let systemSettings = await cache.getSystemSettings(); // serviceClient.get(new dtos.GetSystemSettings({ accountId: shared.accountId }));
        this.refresh(1);
    }

    async refresh(page = this.pagination.page || 1, sort = this.sort) {
        this.loading = true;
        let request = new dtos.ListAISessions({
            accountIds: [shared.accountId],
            countPerPage: this.pageSize,
            page: page - 1,
            sortField: sort.field,
            sortOrder: sort.order,
            simplifiedPaging: true,
        });
        let response = await serviceClient.get(request);
        let currentlySelected = this.sessions.filter(ep => this.selectedSessionIds.indexOf(ep.id) >= 0);
        this.sessions = [...currentlySelected, ...response.items.filter(c => this.selectedSessionIds.indexOf(c.id) < 0)];
        let pager = { ...this.pagination };
        pager.current = page;
        pager.total = page * this.pageSize + (response.hasMorePages ? 1 : 0);
        pager.pageSize = this.pageSize;
        pager.showSizeChanger = true;
        pager.pageSizeOptions = ["10", "20", "50", "100", "250"];
        pager.onShowSizeChange = (c, v) => this.pageSize = v;

        this.pagination = pager;
        this.loading = false;

        localStorage.setItem("AISessionIndex.pagination.pageSize", this.pageSize.toString());
    }

    checkFilterSubmit(ev: KeyboardEvent) {
        if (ev.which == 13) {
            this.refresh();
        }
    }

    async deleteSession(session: dtos.AISessionInfo) {
        await serviceClient.delete(new dtos.DeleteAISession({
            sessionId: session.id
        }));
        let idx = this.sessions.indexOf(session);
        this.sessions.splice(idx, 1);
        this.forceUpdate();
        ui.message.info("Session deleted");
    }

    async deleteSessions() {
        this.loading = true;
        for (let sessionId of this.selectedSessionIds) {
            await serviceClient.delete(new dtos.DeleteAISession({ sessionId: sessionId }));
        }
        this.selectedSessionIds = [];
        this.refresh();
        this.loading = false;
    }


    async newSession(ev: React.FormEvent) {
        ev.preventDefault();
        ev.stopPropagation();
        let newSession = await serviceClient.post(new dtos.NewAISession({
            accountId: shared.accountId,
            purpose: this.newFlowPurpose
        }));
        ui.message.success("Session created");
        window.location.hash = "/ai/sessions/" + newSession.id;
    }

    render() {
        const rowSelection = {
            selectedRowKeys: this.selectedSessionIds,
            onChange: keys => this.selectedSessionIds = keys
        };

        function getValue(rec: dtos.CustomerInfo, f: dtos.CustomerDataField) {
            rec.data[f.name] = rec.data[f.name] || new dtos.Value();
            return rec.data[f.name];
        }

        return (
            <div>
                <PageTitle title="AI Sessions" />
                <AccountHeader title="AI Sessions" icon="fa fa-users" />
                <ui.Button.Group style={{ marginBottom: 16 }}>
                    {shared.canWrite() && <ui.Button type="primary" onClick={() => this.showNewSession = true}>New Session</ui.Button>}
                    {this.selectedSessionIds.length > 0 && shared.canDelete() && <ui.Popconfirm title="Are you sure you want to delete the selected AI sessions?" onConfirm={() => this.deleteSessions()}><ui.Button danger>Delete Sessions</ui.Button></ui.Popconfirm>}
                </ui.Button.Group>

                <ui.Table className="hide-pagination-buttons" rowSelection={rowSelection} loading={this.loading} dataSource={this.sessions} rowKey="id" pagination={this.pagination} onChange={(p, f, s) => this.refresh(p.current, s)}>
                    <ui.Table.Column dataIndex="purpose" title="Purpose" render={(text, rec: dtos.AISessionInfo) => <>
                        <Link to={`/ai-sessions/${rec.id}`}>{rec.purpose || "(No Purpose)"}</Link>
                    </>} />

                    <ui.Table.Column title="Last Modified" render={(text, rec: dtos.CustomerInfo) => <span>{moment(rec.dateLastModified).format("LLLL")} by {rec.lastModifiedBy}</span>} />
                </ui.Table>

                <ui.Modal title="New Session" visible={this.showNewSession} onOk={(ev) => this.newSession(ev)} onCancel={() => this.showNewSession = false} okText="Save">
                    <ui.Form layout="vertical" onSubmitCapture={(ev) => this.newSession(ev)}>
                        <button type="submit" style={{ position: "absolute", top: -9999, left: -9999 }}>Submit</button>
                        <ui.Form.Item label="Purpose">
                            <AutoFocus visible={this.showNewSession}>
                                <ui.Input value={this.newFlowPurpose} onChange={v => this.newFlowPurpose = v.target.value} />
                            </AutoFocus>
                        </ui.Form.Item>
                    </ui.Form>
                </ui.Modal>
            </div>
        );
    }
}